import { camelCase, upperFirst } from 'lodash';
import { shuffleArray } from 'root/lib/utilityFunctions';

// helper function for creating wordData from evidence -------------------------
export const parseEvidenceDataToWordData = (evidenceData) => {
  const wordData = [];
  let wordCountInItem = 0;
  evidenceData.forEach((evidence) => {
    // '_|\S+|\n$' = matches underscores OR every non whitespace chunks OR newline character
    const wordsInEvidence = evidence.text.match(/_|\S+|\n/g);
    // don't count extra spaces and new lines to correctly apply highlighting styles
    const extraCharactersLength = wordsInEvidence.filter(chunk => chunk === '_' || chunk === '\n').length;
    const phraseLength = wordsInEvidence.length - extraCharactersLength;
    wordCountInItem += phraseLength;

    let indexInPhrase = -1;
    wordsInEvidence.forEach((word, index) => {
      if (word === '\n') {
        wordData.push({
          isNewLine: true,
          key: `${index}-${evidence.evidenceIndex}`,
        });
      } else if (word === '_') {
        wordData.push({
          isExtraSpace: true,
          key: `${index}-${evidence.evidenceIndex}`,
        });
      } else {
        indexInPhrase += 1;
        wordData.push({
          text: word,
          evidenceIndex: evidence.evidenceIndex,
          isCorrect: evidence.isCorrect,
          phraseLength,
          indexInPhrase,
          key: `${word}-${index}-${evidence.evidenceIndex}`,
        });
      }
    });
  });
  return { wordData, wordCountInItem };
};

export const parseEvidenceData = data =>
  data.map((phrase, index) => ({
    ...phrase,
    evidenceIndex: index,
    isSelected: false,
    isDiscarded: false,
  }));

export const parseTraitText = text => upperFirst(camelCase(text));

export const parseCharacters = (items, superlatives) =>
  items.map(item => ({
    ...item,
    correctTraits: item.correctTraits.map(trait => ({
      ...trait,
      isCompleted: false,
    })),
    superlatives: shuffleArray(superlatives.map(superlative => ({
      ...superlative,
      isCorrect: superlative.id === item.correctSuperlativeId,
    }))),
  }));

export const parseAndShuffleTraits = traits =>
  shuffleArray(traits).map((trait, index) =>
    ({
      ...trait,
      isDiscarded: false,
      index,
    }));
